import BrsrLandingPageContainer from "./containers/BrsrLandingPageContainer";
export default BrsrLandingPageContainer;
